import { getMonth as getMonthFns } from 'date-fns';

export default function getMonth(date: Date): number {
  return getMonthFns(date);
}
